import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core'
import type { DeletePaymentCard } from './deletePaymentCard.graphql'

async function callDeletePaymentCard(
  variables: VariablesOf<typeof DeletePaymentCard>
): Promise<ResultOf<typeof DeletePaymentCard>> {
  const result = await fetch('/api/v2/delete-payment-card', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      variables,
    }),
  })
  if (!result.ok) {
    throw new Error(`Network error: ${result.status}`)
  }
  const json = await result.json()
  if ('errors' in json) {
    throw new Error(`GraphQL Error: ${JSON.stringify(json.errors)}`)
  }
  return json.data
}

export async function deletePaymentCard(variables: VariablesOf<typeof DeletePaymentCard>) {
  const result = await callDeletePaymentCard(variables)
  if (result.deletePaymentCard === null) {
    return null
  }
  if (result.deletePaymentCard.__typename === 'DeletePaymentCardErrorUndeletable') {
    return result.deletePaymentCard.deletableDateFrom
  }
  throw new Error('unreachable')
}
